import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { UserRepositoryService } from "../services/user-repository.service";
import { User } from "../shared/models/user.model";
import { MsalBroadcastService, MsalService } from "@azure/msal-angular";
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionRequiredAuthError,
  InteractionStatus,
  InteractionType,
  PopupRequest,
  RedirectRequest,
} from "@azure/msal-browser";
import { filter, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: "app-sign-in-redirect",
  templateUrl: "./sign-in-redirect.component.html",
  styleUrls: ["./sign-in-redirect.component.scss"],
})
export class SignInRedirectComponent implements OnInit, OnDestroy {
  user: User = null;
  private readonly _destroying$ = new Subject<void>();
  loginDisplay = false;
  isLoggedIn = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private msalBroadcastService: MsalBroadcastService,
    private msalService: MsalService,
    private userRepository: UserRepositoryService
  ) {}

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  ngOnInit() {
    //  await this.msalService.instance.handleRedirectPromise();

    this.msalBroadcastService.msalSubject$.subscribe({
      next: (msalSubject) => {
       
        if (msalSubject.eventType === "msal:acquireTokenFailure") {
          // alert('From Sign Redirect')
          this.msalService.logout();
 
        }
      },
    });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(async () => {
        if (!this.authService.authenticated) {
          this.router.navigate(["/signin"], { replaceUrl: true });
         //
        } else {
          this.userRepository.getMe().subscribe((user: User) => {
            if (user) {
              this.user = user;
              this.router.navigate(["/home"], { replaceUrl: true });
            }
          });
        }
      });
  }
}
